import { ReactElement } from 'react';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';
import { useTranslation } from 'modules/i18n';
import { Tabs } from 'modules/liquidStaking/components/TabsDialog/components/Tabs';
import { LiquidStakingTab } from 'modules/liquidStaking/const';
import { LiquidStakingPoolContext } from 'modules/liquidStaking/LiquidStakingPoolContext';

import { translation } from './translation';

export function TabsDialog(): ReactElement {
  const { t, keys } = useTranslation(translation);

  const { onClose, isOpened, context } = useDialog<
    LiquidStakingTab | undefined
  >(KnownDialogs.lsTabsDialog);

  return (
    <Dialog open={isOpened} title={t(keys.title)} onClose={onClose}>
      <LiquidStakingPoolContext.Provider value={LIQUID_STAKING_TOKEN_ADDRESS}>
        <Tabs defaultTab={context} />
      </LiquidStakingPoolContext.Provider>
    </Dialog>
  );
}
